export default __webpack_public_path__ + "images/0xf55bec9cafdbe8730f096aa55dad6d22d44099df.png";